import React from "react";
import { DepositWithdrawDialogTab, DialogState } from "../../global/types";
import { DepositWithdrawDialog } from "../dialogs/deposit-withdraw/deposit-withdraw-dialog.component";
import { TePageHeader } from "../layout/te-header.component";
import { TeMain } from "../layout/te-main-body.component";
import { TeMainNavigation } from "../layout/te-main-navigation.component";
import { TraderPageSidebar } from "../sidebar/trader-page-sidebar.component";
import { TePageFooter } from "../layout/te-footer.component";
import { TeTraderBody } from "../layout/te-trader-body-component";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const darkTheme = createTheme({ palette: { mode: "dark" } });

const ZeroXLogo: string = require("../../assets/img/logo_0x.svg").default;
const AAVELogo: string = require("../../assets/img/logo_aave.svg").default;

interface ITraderBotPageProps {
  activeRoute: string;
  dialogState: DialogState;
  dialogTab: DepositWithdrawDialogTab;
}

const defaultProps: ITraderBotPageProps = {
  activeRoute: "",
  dialogState: "CLOSED",
  dialogTab: "NONE"
};

// TRADING BOT PAGE
export function TraderBotPage(props = defaultProps) {
  return (
    <div className={`etx-app-wrapper ${props.dialogState === "OPEN" ? "overlay-show" : ""}`}>
      <TePageHeader
        title="Trendespresso"
        description={
          <div style={{ display: "flex", alignItems: "center", marginBottom: "-28px" }}>

            <div style={{ marginRight: "20px" }}>
              <a href="https://0x.org/" target="_blank" rel="noreferrer">
                <img
                  // src="https://assets.website-files.com/640bf70a17d12b42d97a052b/641a220f0ec6db351732ce83_brand-powered-by-0x-white.svg"
                  src={ZeroXLogo}
                  alt="0x"
                  style={{ width: "60px", height: "60px", filter: "brightness(450%)", marginBottom: "2px" }}
                />
              </a>
            </div>

            <div style={{ marginRight: "20px" }}>
              <a href="https://aave.com/" target="_blank" rel="noreferrer">
                <img
                  // src="https://aave.com/aaveGhost.svg"
                  src={AAVELogo}
                  alt="AAVE"
                  style={{ width: "80px", height: "80px", filter: "brightness(450%)", marginBottom: "-1px" }}
                />
              </a>
            </div>
          </div>
        }
        acceptedFcaNotice={true}
      />

      <TeMain
        navigation={<TeMainNavigation activeRoute={props.activeRoute} />}
        main={
          <ThemeProvider theme={darkTheme}>
            <TeTraderBody />
          </ThemeProvider>
        }
        sidebar={<TraderPageSidebar />}
      />

      <TePageFooter />
      {
        props.dialogState === "OPEN"
          ? <DepositWithdrawDialog dialogTab={props.dialogTab} />
          : ""
      }
    </div>
  );
}